// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17Q96","left":"styles_left__2TfWP"};